import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {flexAbsoluteCenter, flexDirection, mb, position, textAlign} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {consoleError} from "@pg-mono/logger";

import type {IRPStore} from "../../../../app/rp_reducer";
import type {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {fetchDistrictsWithCheck} from "../../actions/fetch_districts_with_check";
import {PricesViewType} from "../../helpers/prices_view_type";
import {DistrictsChart} from "./DistrictsChart";

export interface IDistrictData {
    slug_district: string;
    district: string;
    avg_price_m2: number;
    date: string;
}

interface Props {
    region: IRegionReportPrice;
    type: PricesViewType;
}

export const PricesMapDistricts = (props: Props) => {
    const [districtsData, setDistrictData] = useState<IDistrictData[]>([]);

    const pricesAvailableDate = useSelector((store: IRPStore) => store.report.price.pricesAvailableDate);

    useEffect(() => {
        fetchDistrictsWithCheck({regionSlug: props.region.slug, type: props.type, date: pricesAvailableDate?.date})
            .then((response) => {
                setDistrictData(response);
            })
            .catch((error) => {
                consoleError("fetchDistrictsData error: ", error);
            });
    }, []);

    return (
        <div css={[flexAbsoluteCenter, flexDirection("column"), position("relative")]}>
            <Text variant="headline_2" css={[mb(3), textAlign("center")]}>
                Średnie ceny mieszkań w dzielnicach {props.region.name_declension_what}
            </Text>

            {districtsData && districtsData.length !== 0 ? (
                <DistrictsChart districtsData={districtsData} region={props.region} />
            ) : (
                <div css={flexAbsoluteCenter}>
                    <Loader size="lg" />
                </div>
            )}
        </div>
    );
};
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {flexAbsoluteCenter, flexDirection, mb, position, textAlign} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {consoleError} from "@pg-mono/logger";

import type {IRPStore} from "../../../../app/rp_reducer";
import type {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {fetchDistrictsWithCheck} from "../../actions/fetch_districts_with_check";
import {PricesViewType} from "../../helpers/prices_view_type";
import {DistrictsChart} from "./DistrictsChart";

export interface IDistrictData {
    slug_district: string;
    district: string;
    avg_price_m2: number;
    date: string;
}

interface Props {
    region: IRegionReportPrice;
    type: PricesViewType;
}

export const PricesMapDistricts = (props: Props) => {
    const [districtsData, setDistrictData] = useState<IDistrictData[]>([]);

    const pricesAvailableDate = useSelector((store: IRPStore) => store.report.price.pricesAvailableDate);

    useEffect(() => {
        fetchDistrictsWithCheck({regionSlug: props.region.slug, type: props.type, date: pricesAvailableDate?.date})
            .then((response) => {
                setDistrictData(response);
            })
            .catch((error) => {
                consoleError("fetchDistrictsData error: ", error);
            });
    }, []);

    return (
        <div css={[flexAbsoluteCenter, flexDirection("column"), position("relative")]}>
            <Text variant="headline_2" css={[mb(3), textAlign("center")]}>
                Średnie ceny mieszkań w dzielnicach {props.region.name_declension_what}
            </Text>

            {districtsData && districtsData.length !== 0 ? (
                <DistrictsChart districtsData={districtsData} region={props.region} />
            ) : (
                <div css={flexAbsoluteCenter}>
                    <Loader size="lg" />
                </div>
            )}
        </div>
    );
};
